import { render, staticRenderFns } from "./manage-auth.vue?vue&type=template&id=5d40fd03&scoped=true"
import script from "./manage-auth.vue?vue&type=script&lang=ts"
export * from "./manage-auth.vue?vue&type=script&lang=ts"
import style0 from "./manage-auth.vue?vue&type=style&index=0&id=5d40fd03&prod&lang=scss&scoped=true"
import style1 from "./manage-auth.vue?vue&type=style&index=1&id=5d40fd03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40fd03",
  null
  
)

export default component.exports